import React, { useEffect, useState } from "react";
import BackIcon from "../../../comman/action/BackIcon";
import { Avatar } from "@mui/material";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LanguageTwoToneIcon from "@mui/icons-material/LanguageTwoTone";
import { Link, useParams } from "react-router-dom";
import { cashConverter, dateFormat } from "../../../components/Form";
import { Button } from "../../../components/Button/Button";
import NotFound from "../../../components/not-found/NotFound";
import PsychologySharpIcon from "@mui/icons-material/PsychologySharp";
import { DescriptionModal, ViewMore } from "../../../comman/action/ViewMore";
import { ViewIcon } from "../../../comman/action/ViewIcon";
import { PaginationShow } from "../../../comman/action/Pagination";
import {
  fundHistoryList,
  fundHistoryListApi,
  resourceDetailsApi,
} from "../../../services/resource";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { catchMessage, elseMessage } from "../../../comman/Message";

const ViewResourceDetails = () => {
  const { id } = useParams(); // Get the id from the route parameters
  const [resourceDetail, setResourceDetail] = useState(null);
  const [image, setImage] = useState(null);
  const [fundHistoryList, setFundHistoryList] = useState([]);
  const [desModal, setDesModal] = useState(false);
  const [desValue, setDesValue] = useState("");
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const amount = 2345;
  // console.log("details Id", id)

  //--------handle-page------------
  const handlePageChange = (event) => {
    setPage(event);
  };
  console.log(resourceDetail?.url, "resourceDetail?.url");
  //--------description-modal------------
  const handleSeeMore = (des) => {
    setDesModal(true);
    setDesValue(des);
  };
  //-----------listing-fund-history---------------
  useEffect(() => {
    const fathFundHistory = async (
      activePage = page,
      resourceId = id,
      status = "accept"
    ) => {
      setFundHistoryList([]);
      try {
        const res = await fundHistoryListApi({
          page: activePage,
          resourceId,
          status,
        });
        if (res?.data?.status === 200) {
          // console.log("fundHistory", res?.data?.data?.aids)
          setFundHistoryList(res?.data?.data?.aids || []);
          setTotal(res?.data?.data?.total || 0);
        } else {
          elseMessage(res);
          setFundHistoryList([]);
        }
      } catch (err) {
        catchMessage(err);
        setFundHistoryList([]);
      }
    };
    fathFundHistory(page, id, "accept");
  }, [id]);
  //-----------single-details---------------
  useEffect(() => {
    const singleDetails = async () => {
      try {
        showLoader();
        const res = await resourceDetailsApi(id);
        if (res?.data?.status === 200) {
          // console.log("recur Details", res?.data?.data?.resource)
          hideLoader();
          setResourceDetail(res?.data?.data?.resource);
          setImage(res?.data?.data?.resource);
        } else {
          elseMessage(res);
          hideLoader();
        }
      } catch (err) {
        catchMessage(err);
        hideLoader();
      }
    };
    singleDetails();
  }, [id]);
  return (
    <>
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <h4 className="Title">
              <BackIcon />
              Resource Details
            </h4>
            <div className="">
              <Button
                className="mx-1"
                to={`/resource-management/fund-request/${id}`}
              >
                Fund Requests
              </Button>
              <Button to={`/resource-management/edit/${id}`}>
                Edit Resource{" "}
              </Button>
            </div>
          </div>
          <div className="customer_details">
            <div className="innner">
              <div className="row">
                <div className="col-4">
                  <Avatar
                    className="w-100"
                    variant="rounded"
                    src={resourceDetail?.coverImage}
                    sx={{
                      width: 400,
                      height: 200,
                      border: 1,
                      borderRadius: 3,
                      borderColor: "#9dc4b4",
                    }}
                  >
                    <InsertPhotoIcon sx={{ fontSize: 100 }} />
                  </Avatar>

                  <div className="mt-2">
                    <LanguageTwoToneIcon
                      sx={{ color: "#C86337", marginRight: 1 }}
                    />
                    <span>
                      External link
                      <span>
                        {" "}
                        :{"  "}
                        <a
                          href={resourceDetail?.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {resourceDetail?.url || "N/A"}
                        </a>
                        {/* <Link>{resourceDetail?.url || "N/A"}</Link> */}
                      </span>
                    </span>
                  </div>
                </div>
                <div className="col-4">
                  <div className="d-flex justify-content-between">
                    <h4>{resourceDetail?.title || "N/A"}</h4>
                  </div>
                  <p className="mt-2 mb-2">
                    <LocationOnIcon sx={{ color: "#C86337" }} />
                    {resourceDetail?.locationType === "world" ? (
                      <span>{resourceDetail?.locationType}</span>
                    ) : (
                      <>
                        <span>{resourceDetail?.city?.name || "N/A"}, </span>
                        <span>{resourceDetail?.state?.name || "N/A"}, </span>
                        <span>{resourceDetail?.country?.name || "N/A"}, </span>
                      </>
                    )}
                  </p>
                  <p className="mt-2 mb-2 line-break">
                    {(resourceDetail?.description &&
                      resourceDetail.description.replace(/\s+/g, " ")) ||
                      "N/A"}
                  </p>
                  {/* <p className='mt-2 mb-2 line-break'>{resourceDetail?.about.trim() || "N/A"}</p> */}
                  <b>{resourceDetail?.hashTag}</b>
                </div>
                <div className="col-4">
                  <h4 className="mb-2">Funds details</h4>
                  <ul>
                    <li>
                      <strong>Total donated </strong>
                      <span>
                        :{" "}
                        {resourceDetail?.totalDonated
                          ? Math.trunc(resourceDetail.totalDonated)
                          : "N/A"}
                      </span>
                    </li>
                    <li>
                      <strong>Donated in last 30 days </strong>
                      <span>
                        :{" "}
                        {resourceDetail?.donatedLast30Days
                          ? Math.trunc(resourceDetail.donatedLast30Days)
                          : "N/A"}
                      </span>
                    </li>
                    <li>
                      <strong>Total Fund requests</strong>
                      <span>
                        :{" "}
                        {resourceDetail?.totalFundRequests
                          ? Math.trunc(resourceDetail.totalFundRequests)
                          : "N/A"}
                      </span>
                    </li>
                    <li>
                      <strong>Requests in last 30 days</strong>
                      <span>
                        :{" "}
                        {resourceDetail?.requestsLast30Days
                          ? Math.trunc(resourceDetail.requestsLast30Days)
                          : "N/A"}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* ---------------listing-community--------------------- */}
          <h4 className="mt-4">Spent Funds History</h4>
          <div className="content-table">
            <table>
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th>Username</th>
                  <th>Email address</th>
                  <th>Spent on</th>
                  <th>Fund Spent</th>
                  <th>Description</th>
                  <th className="text-center"> Action </th>
                </tr>
              </thead>
              <tbody>
                {fundHistoryList.length > 0 ? (
                  fundHistoryList.map(
                    ({ _id, user, createdAt, amount, need }, index) => {
                      return (
                        <React.Fragment key={index}>
                          <tr>
                            <td>{++index + (page - 1) * 10}</td>
                            <td>{user?.userName || "N/A"}</td>
                            <td>{user?.email || "N/A"}</td>
                            <td>{dateFormat(createdAt)}</td>
                            <td>{cashConverter(amount) || "N/A"}</td>
                            <td>
                              <ViewMore
                                value={need}
                                handleSeeMore={handleSeeMore}
                              />
                            </td>
                            <td>
                              <div className="d-flex justify-content-center">
                                <ViewIcon
                                  to={`/user-management/view-details/${user?._id}`}
                                />
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    }
                  )
                ) : (
                  <NotFound
                    cols={7}
                    msg="No Funds History Found!"
                    icon={<PsychologySharpIcon style={{ fontSize: 48 }} />}
                    // loader={loader}
                  />
                )}
              </tbody>
            </table>
          </div>
          <PaginationShow
            activePage={page}
            total={total}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>

      <DescriptionModal
        show={desModal}
        close={() => setDesModal(false)}
        value={desValue}
      />
    </>
  );
};

export default ViewResourceDetails;
